import './glowing-button.css';

export default({onClick}) => {

    return <button onClick={onClick} class='glowing-btn'><span class='glowing-txt'>L<span class='faulty-letter'>A</span>UNCH</span></button>
}